import { PartnerSearchList } from '@/legacy/components/PartnerSearchList'
import type { PartnersListProps } from '@/legacy/components/PartnerSearchList/types'

const PartnerSearchListBlock = ({
  items,
  spaceIn,
  settingsLink,
  title,
  subtitle,
  concatenation,
  cardButtonLabel,
}: PartnersListProps) => {
  const hasItems = !!items
  if (!hasItems) return null
  return (
    <PartnerSearchList
      title={title}
      subtitle={subtitle}
      cardButtonLabel={cardButtonLabel}
      concatenation={concatenation}
      items={items}
      spaceIn={spaceIn}
      settingsLink={settingsLink}
    />
  )
}
export default PartnerSearchListBlock
